<template>
  <v-card
    v-if="visible"
    ref="goods_overview"
    id="goods_overview"
    elevation="0"
    class="mx-auto secondary rounded-0"
  >
    <CardHeader title="3. HVAD?" />
    <v-row v-for="item in goods" :key="item.id">
      <v-col
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'pt-4 pb-0 px-10'"
      >
        <Goods :goods="item" />
      </v-col>
    </v-row>
    <v-card-actions
      v-if="allowAddGoods"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pt-0 pb-7 px-9'"
    >
      <v-spacer />
      <v-btn class="text-right" @click="addGoods">
        <v-icon style="font-size: 12px;">
          {{ this.addIcon }}
        </v-icon>
        <span class="text-right" align-self="center">Tilføj gods</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Goods from "@/components/BookingGoods.vue";
import { dictionary } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "GoodsOverview",
  components: {
    Goods,
    CardHeader
  },
  created() {
    const allowAddGoods = this.$store.getters["user/allowAddGoods"];
    this.allowAddGoods = allowAddGoods == null || allowAddGoods;
  },
  data: () => ({
    allowAddGoods: true,
    addIcon: dictionary.mdi.add
  }),
  computed: {
    visible: {
      get() {
        return (
          this.$store.state.booking.data.account &&
          this.$store.state.booking.data.pickup.address.address &&
          this.$store.state.booking.data.pickup.address.name &&
          this.$store.state.booking.data.delivery.address.address &&
          this.$store.state.booking.data.delivery.address.name
        );
      }
    },
    goods() {
      return this.$store.state.booking.data.goods;
    }
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs.goods_overview);
          });
        }
      }
    }
  },
  methods: {
    addGoods() {
      this.$store.commit("booking/addGoods");
    }
  }
};
</script>
